module.exports = __webpack_public_path__ + "static/img/ETHAN-READ.24bcbb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ETHAN-READ.jpg
// module id = LAfc
// module chunks = 0